var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04Socket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 245.309,
    height: 167.255,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st810{fill:#38454f}.st811{fill:#546a79}")), /*#__PURE__*/React.createElement("path", {
    d: "M42.076 80.586c14.091 23.65 59.454 0 65.136 27.416 6.74 32.517 25.561 71.823 59.448 55.388 29.257-14.189 12.774-49.418 37.354-63.172 12.8-7.162 49.707-4.904 39.547-43.377-5.096-19.297-3.903-26.859-19.744-36.37-30.886-18.544-48.415 5.351-78.455 7.275C117.697 29.518 93.231-11.539 63.775 3.2 35.176 17.51 25.682 53.072 42.076 80.586z",
    id: "path1201",
    style: {
      fill: "#ecf0f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1227",
    transform: "translate(-52.3 -1082.602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3 1211.882v-85.352c0-7.468 5.868-13.336 13.336-13.336h128.028c7.468 0 13.336 5.868 13.336 13.336v85.352c0 7.468-5.868 13.336-13.336 13.336H65.636c-7.468 0-13.336-5.868-13.336-13.336",
    id: "path1205",
    style: {
      fill: "#aeb2b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.637 1123.863h120.026c3.734 0 6.668 2.934 6.668 6.668v77.35c0 3.734-2.934 6.668-6.668 6.668H69.637c-3.734 0-6.668-2.934-6.668-6.668v-77.35c0-3.734 2.934-6.668 6.668-6.668",
    id: "path1207",
    style: {
      fill: "#cbd4d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.638 1193.211h48.01v-48.01h-48.01z",
    id: "path1209",
    style: {
      fill: "#e8edee"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1219"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st810",
    d: "M108.312 1182.542h-5.334c-1.6 0-2.667-1.067-2.667-2.667 0-1.6 1.067-2.667 2.667-2.667h5.334c1.6 0 2.667 1.067 2.667 2.667 0 1.6-1.067 2.667-2.667 2.667",
    id: "path1211"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st810",
    d: "M92.309 1182.542h-5.335c-1.6 0-2.667-1.067-2.667-2.667 0-1.6 1.067-2.667 2.667-2.667h5.335c1.6 0 2.667 1.067 2.667 2.667 0 1.6-1.067 2.667-2.667 2.667",
    id: "path1213"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st810",
    d: "M97.643 1166.539c-1.6 0-2.667-1.067-2.667-2.667v-8.002c0-1.6 1.067-2.667 2.667-2.667 1.6 0 2.667 1.067 2.667 2.667v8.002c0 1.6-1.067 2.667-2.667 2.667",
    id: "path1215"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st810",
    d: "M177.66 1193.211h-32.007c-4.268 0-8.002-3.468-8.002-8.002v-21.071c0-3.467 1.334-6.935 4.001-9.335l6.668-6.935c1.867-1.867 4.268-2.667 6.668-2.667h13.603c2.401 0 4.801 1.067 6.668 2.667l6.668 6.668c2.401 2.401 4.001 5.868 4.001 9.335v21.338c-.266 4.535-3.733 8.002-8.268 8.002",
    id: "path1217"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1225"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st811",
    d: "M201.666 1246.556c-.8 0-1.334-.267-1.867-.8-3.467-3.467-11.736-3.734-17.07-1.867-9.069 3.467-18.937-.533-22.138-8.802-1.067-2.134-1.6-4.534-1.6-7.202v-50.678c0-1.6 1.067-2.667 2.667-2.667 1.6 0 2.667 1.067 2.667 2.667v50.678c0 1.867.267 3.734 1.067 5.334 2.401 5.601 9.069 8.268 15.47 5.868 6.935-2.667 17.604-2.134 22.672 2.934 1.067 1.067 1.067 2.667 0 3.734-.535.534-1.068.801-1.868.801",
    id: "path1221"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st811",
    d: "M164.324 1171.873h-5.334c-1.6 0-2.667-1.067-2.667-2.667 0-1.6 1.067-2.667 2.667-2.667h5.334c1.6 0 2.667 1.067 2.667 2.667 0 1.6-1.067 2.667-2.667 2.667",
    id: "path1223"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04Socket);
export default __webpack_public_path__ + "static/media/04-Socket.fea4b63fabcec6d98d0d43ac49f5cada.svg";
export { ForwardRef as ReactComponent };